import SettingsExpertTeamMemberModule from './team-member.module'

export default SettingsExpertTeamMemberModule
